import React from "react";
import { TIPOS_EMPRESA } from "../constants/empresas";

function Modal({ open, title, onClose, size = "modal-lg", children }) {
  if (!open) return null;
  return (
    <div
      className="modal fade show d-block management-modal"
      tabIndex="-1"
      style={{ backgroundColor: "rgba(15, 23, 42, 0.45)" }}
      aria-modal="true"
      role="dialog"
    >
      <div className={`modal-dialog ${size} modal-dialog-centered`} role="document">
        <div className="modal-content">
          <div className="modal-header border-0">
            <h5 className="modal-title">{title}</h5>
            <button type="button" className="btn-close" aria-label="Cerrar" onClick={onClose} />
          </div>
          {children}
        </div>
      </div>
    </div>
  );
}

export default function EmpresaFormModal({
  modal,
  formNuevo,
  setFormNuevo,
  formEditar,
  setFormEditar,
  saving,
  deleting,
  cerrarModal,
  handleCrear,
  handleActualizar,
  handleEliminar,
  empresaEditando,
}) {
  const renderForm = (form, setForm, onSubmit, isEdit = false) => (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        onSubmit?.();
      }}
    >
      <div className="modal-body pt-0">
        <div className="row g-3">
          <div className="col-md-6">
            <label className="form-label management-label">Nombre *</label>
            <input
              className="form-control"
              value={form.nombre}
              onChange={(e) => setForm((prev) => ({ ...prev, nombre: e.target.value }))}
              required
            />
          </div>
          <div className="col-md-6">
            <label className="form-label management-label">RUC</label>
            <input
              className="form-control"
              value={form.ruc}
              onChange={(e) => setForm((prev) => ({ ...prev, ruc: e.target.value }))}
              placeholder="Opcional"
            />
          </div>
          <div className="col-md-6">
            <label className="form-label management-label">Telefono</label>
            <input
              className="form-control"
              value={form.telefono}
              onChange={(e) => setForm((prev) => ({ ...prev, telefono: e.target.value }))}
              placeholder="09xxxxxxx"
            />
          </div>
          <div className="col-md-6">
            <label className="form-label management-label">Email</label>
            <input
              type="email"
              className="form-control"
              value={form.email}
              onChange={(e) => setForm((prev) => ({ ...prev, email: e.target.value }))}
              placeholder="correo@dominio.com"
            />
          </div>
          <div className="col-md-6">
            <label className="form-label management-label">Tipo</label>
            <select
              className="form-select"
              value={form.tipo}
              onChange={(e) => setForm((prev) => ({ ...prev, tipo: e.target.value }))}
            >
              {TIPOS_EMPRESA.map((tipo) => (
                <option key={tipo.value} value={tipo.value}>
                  {tipo.label}
                </option>
              ))}
            </select>
          </div>
          <div className="col-md-6 d-flex align-items-center pt-4">
            <div className="form-check">
              <input
                className="form-check-input"
                type="checkbox"
                id={`emp-activo-${isEdit ? "edit" : "new"}`}
                checked={form.activo}
                onChange={(e) => setForm((prev) => ({ ...prev, activo: e.target.checked }))}
              />
              <label className="form-check-label" htmlFor={`emp-activo-${isEdit ? "edit" : "new"}`}>
                Activa
              </label>
            </div>
          </div>
        </div>
      </div>
      <div className="modal-footer border-0 pt-0">
        <button type="button" className="btn btn-outline-secondary" onClick={cerrarModal}>
          Cancelar
        </button>
        <button type="submit" className="btn management-btn-primary" disabled={saving}>
          {saving ? "Guardando..." : isEdit ? "Actualizar" : "Crear"}
        </button>
      </div>
    </form>
  );

  return (
    <>
      <Modal open={modal === "crear"} title="Nueva empresa" onClose={cerrarModal}>
        {renderForm(formNuevo, setFormNuevo, handleCrear)}
      </Modal>

      <Modal open={modal === "editar"} title="Editar empresa" onClose={cerrarModal}>
        {renderForm(formEditar, setFormEditar, handleActualizar, true)}
      </Modal>

      <Modal open={modal === "eliminar"} title="Eliminar empresa" onClose={cerrarModal} size="modal-md">
        <div className="modal-body pt-0">
          Seguro que deseas eliminar la empresa <strong>{empresaEditando?.nombre}</strong>?
          <p className="text-muted mb-0">Esta accion deshabilitara el registro.</p>
        </div>
        <div className="modal-footer border-0 pt-0">
          <button type="button" className="btn btn-outline-secondary" onClick={cerrarModal}>
            Cancelar
          </button>
          <button type="button" className="btn btn-danger" onClick={handleEliminar} disabled={deleting}>
            {deleting ? "Eliminando..." : "Eliminar"}
          </button>
        </div>
      </Modal>
    </>
  );
}

